<div class="d-flex flex-column playbook-usage-column align-items-start">
    <span>
        {{ dataItem[columnOptions.field] }}
    </span>
</div>